import React, { useState, useMemo } from "react";
import { Gantt, Task, ViewMode } from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import dayjs from "dayjs";
import "dayjs/locale/vi";

dayjs.locale("vi");

const tasks: Task[] = [
  {
    start: new Date(2025, 8, 25),
    end: new Date(2025, 8, 27),
    name: "Đã hoàn thành",
    id: "Task 1",
    type: "task",
    progress: 100,
    isDisabled: false,
    styles: { progressColor: "#4caf50", progressSelectedColor: "#2e7d32" }
  },
  {
    start: new Date(2025, 8, 28),
    end: new Date(2025, 8, 30),
    name: "Đang xử lý",
    id: "Task 2",
    type: "task",
    progress: 50,
    dependencies: ["Task 1"],
    styles: { progressColor: "#2196f3", progressSelectedColor: "#1565c0" }
  },
  {
    start: new Date(2025, 8, 29),
    end: new Date(2025, 8, 30),
    name: "Đã hủy",
    id: "Task 3",
    type: "task",
    progress: 0,
    styles: { progressColor: "#f44336", progressSelectedColor: "#b71c1c" }
  },
  {
    start: new Date(2025, 9, 1),
    end: new Date(2025, 9, 5),
    name: "Hạn deadline",
    id: "Task 4",
    type: "task",
    progress: 20,
    dependencies: ["Task 2"],
    styles: { progressColor: "#ff9800", progressSelectedColor: "#ef6c00" }
  }
];

export default function App() {
  const [view, setView] = useState<ViewMode>(ViewMode.Day);

  // ✅ Đếm số lượng công việc theo trạng thái
  const stats = useMemo(() => {
    return {
      completed: tasks.filter(t => t.progress === 100).length,
      inProgress: tasks.filter(t => t.progress! > 0 && t.progress! < 100)
        .length,
      canceled: tasks.filter(t => t.progress === 0 && t.name.includes("hủy"))
        .length,
      deadline: tasks.filter(t => t.name.toLowerCase().includes("deadline"))
        .length,
      total: tasks.length
    };
  }, []);

  const formatDate = (date: Date) => {
    return dayjs(date).format("DD/MM/YYYY");
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>Biểu đồ Gantt công việc</h1>

      {/* ✅ Hiển thị thống kê */}
      <div style={{ marginBottom: 20 }}>
        <p>🔢 Tổng công việc: {stats.total}</p>
        <p>✅ Đã hoàn thành: {stats.completed}</p>
        <p>⚡ Đang xử lý: {stats.inProgress}</p>
        <p>❌ Đã hủy: {stats.canceled}</p>
        <p>⏰ Hạn deadline: {stats.deadline}</p>
      </div>

      {/* ✅ Hiển thị Gantt chart */}
      <Gantt
        tasks={tasks}
        viewMode={view}
        locale="vi"
        listCellWidth="" // ✅ bỏ bảng bên trái
        TooltipContent={({ task }) => (
          <div>
            <b>{task.name}</b>
            <br />
            Bắt đầu: {formatDate(task.start)}
            <br />
            Kết thúc: {formatDate(task.end)}
            <br />
            Tiến độ: {task.progress}%
          </div>
        )}
      />
    </div>
  );
}
